<template>
  <div class="avatar" :class="{ 'extra-large': extraLarge, large, medium, gold }" @click="$emit('click')">
    <div class="absolute inset-0 bg-white z-1" v-if="gold"></div>
    <div class="bg-gray-400 initials-bg z-2" v-if="gold"></div>
    <img :src="require(`@/assets/images/user/hexagon.png`)" v-if="gold" class="absolute gold-surround z-4" />
    <div class="content"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'UtilAvatar',
  props: {
    extraLarge: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    gold: Boolean
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  @apply w-10 h-10 text-2xl;
  // zoom: 110%;
  background-color: #b6b5cc;
  border-radius: 50%;
  display: inline-block;
  font-weight: 300;
  position: relative;
  vertical-align: middle;
}

.avatar.gold {
  border-radius: 0%;
}

.avatar.medium {
  @apply w-16 h-16 text-3xl;
}

.avatar.large {
  @apply w-24 h-24 text-5xl;
}

.avatar.extra-large {
  @apply w-48 h-48 text-5xl;
}

.avatar.premium {
  @apply border-blue-700;
}

.avatar .gold-surround {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: auto;
}

.avatar::v-deep img:not(.gold-surround) {
  border-radius: 50%;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 3;
}

.content {
  width: 100%;
  height: 100%;
  z-index: 2;
}

.avatar.gold::v-deep img:not(.gold-surround) {
  border-radius: 0%;
}

.avatar-icon,
.avatar-presence {
  background: #fff;
  top: -25%;
  height: 50%;
  padding: 0.2rem;
  position: absolute;
  right: 14.64%;
  transform: translate(50%, 50%);
  width: 50%;
  z-index: 5;
}

.avatar-presence {
  @apply bg-gray;
  box-shadow: 0 0 0 0.2rem #fff;
  border-radius: 50%;
  height: 0.5em;
  width: 0.5em;

  &.online {
    @apply bg-success;
  }

  &.busy {
    @apply bg-danger;
  }

  &.away {
    @apply bg-warning;
  }
}

.avatar[data-initial]::before {
  color: currentColor;
  content: attr(data-initial);
  left: 50%;
  position: absolute;
  top: 48%;
  transform: translate(-50%, -50%);
  z-index: 3;
}

.initials-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
